var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-family: ', ';\n  font-weight: 600 !important;\n  margin-left: 0px;\n  margin-top: 0px;\n  display: inline-block;\n  text-align: left;\n  p {\n    margin-bottom: 8px;\n  }\n'], ['\n  color: ', ';\n  font-family: ', ';\n  font-weight: 600 !important;\n  margin-left: 0px;\n  margin-top: 0px;\n  display: inline-block;\n  text-align: left;\n  p {\n    margin-bottom: 8px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import { isNil } from 'ramda';
var LabelText = styled.span(_templateObject, function (props) {
  var isLightColor = !isNil(props.light) & props.light === true;
  var isDarkColor = !isNil(props.dark) & props.dark === true;
  var defaultColor = props.theme.colours.primary.dark_text;
  var darkColor = isDarkColor ? props.theme.colours.primary.dark_text : defaultColor;
  var color = isLightColor ? props.theme.colours.neutral.lightest : darkColor;
  return color;
}, function (props) {
  return props.theme.font_body;
});

var Label = function Label(props) {
  var light = props.light,
      dark = props.dark,
      forText = props.forText;
  return forText ? React.createElement('label', {
    htmlFor: forText
  }, React.createElement(LabelText, {
    light: light,
    dark: dark
  }, props.children)) : React.createElement(LabelText, {
    htmlFor: forText,
    light: light,
    dark: dark
  }, props.children);
};

export default Label;